import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import store from '../../Redux/Store';

const ButtonGotoDash = ({ handleClick, text, removeIcon, className }) => {
    const { appType } = store.getState().uiReducers;
    return (
        <button
            onClick={handleClick}
            class={`btn btn-theme ${className} `}
            type="button"
        >
            {!removeIcon && <span class="fas fa-plus me-2"></span>}
            {removeIcon && <span class="me-1">{removeIcon}</span>}
            {text}
        </button>
    )
}

export default ButtonGotoDash